module.exports = __webpack_public_path__ + "assets/img/e37c7fcaa75cd7a2be04b564f0d7c3a8.svg";